import React, { useEffect, useMemo, useState } from "react";
import { useTable, useSortBy, usePagination, useRowSelect } from "react-table";
import "tailwindcss/tailwind.css";
import { Empty } from "antd";
import "../../styles.css";
import Vectorsorting from "../../assets/Vectorsorting.svg";
import ShimmerLoader from "../../loading";
import { useTranslation } from "react-i18next";
import { Navigate, useNavigate } from "react-router-dom";
import CustomPagination from "../../components/CustomWidgets/CustomPagination";
import { Tooltip } from "antd";
import { useSelector } from "react-redux";

const ExpenseManagementTable = ({ additionalData, pagination }) => {
  const { t, i18n } = useTranslation();
  const [flag, setflag] = useState(false);
  const navigate = useNavigate();
  const allStores = useSelector(
    (state) => state?.storeReducer?.selectedStore?.is_select_all_store
  )

  const openOrderList = (id) => {
    navigate(`/vendorDetails?id=${id}`);
  };

  const data = useMemo(
    () =>
      //   additionalData?.status
      //     ? additionalData?.all_product
      additionalData || [],
    [additionalData]
  );

  useEffect(() => {
    if (additionalData?.length === 0 && !flag) {
      const timer = setTimeout(() => {
        setflag(true);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [additionalData, flag]);

  const formatSessionState = state => {
    if (!state) return '';


    return state
      .split('_') // Split by underscore
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
      .join(' '); // Join the words with a space
  };

  const columns = useMemo(
    () => [
      {
        Header: (
          <div className="text-start justify-start" title={t("Date")}>
            {t("Date & Time")}
          </div>
        ),
        accessor: "date",
        headerClassName: "text-start",
        Cell: ({ row }) => (
          <div className="text-start justify-start">{row.original.date}</div>
        ),
      },
      {
        Header: (
          <div className="text-start justify-start" title={t("User")}>
            {t("User")}
          </div>
        ),
         minWidth: 200,   // 👈 increase this
  width: 250,      // 👈 preferred width
  maxWidth: 400,   // 👈 optional limit
        accessor: "user_name",
        headerClassName: "text-start",
        Cell: ({ row }) => (
          <div className="text-start justify-start">
            {row.original.user_name}
          </div>
        ),
      },
      {
        Header: (
          <div className="text-start justify-start" title={t("Transaction Type")}>
            {t("Transaction Type")}
          </div>
        ),
        accessor: "expense_type",
        headerClassName: "text-start",
        Cell: ({ row }) => (
          <div className="text-start justify-start">
            {t(formatSessionState(row.original.expense_type))}
          </div>
        ),
      },
      // {
      //   Header: (
      //     <div className="text-start" title={t("Description")}>
      //       {t("Description")}
      //     </div>
      //   ),
      //   accessor: "remarks",
      //   Cell: ({ row }) => {
      //     const remarks = row.original.remarks || "";
      //     const truncated =
      //       remarks.length > 15 ? `${remarks.substring(0, 15)}...` : remarks;

      //     return (
      //       <div className="text-start">
      //         <Tooltip title={remarks}>
      //           <span className="">{truncated}</span>
      //         </Tooltip>
      //       </div>

      //     );
      //   },
      // },
      {
        Header: (
          <div className="text-start" title={t("Description")}>
            {t("Description")}
          </div>
        ),
        accessor: "remarks",
        Cell: ({ row }) => {
          const remarks = row.original.remarks || "";
          const translatedRemarks = t(remarks); // translate the dynamic remark
          const truncated =
            translatedRemarks.length > 15
              ? `${translatedRemarks.substring(0, 15)}...`
              : translatedRemarks;

          return (
            <div className="text-start">
              <Tooltip title={translatedRemarks}>
                <span>{truncated}</span>
              </Tooltip>
            </div>
          );
        },
      },
      {
        Header: (
          <div className="text-start" title={t("Payment Method")}>
            {t("Payment Method")}
          </div>
        ),
        accessor: "payment_method",
        Cell: ({ row }) => (
          <div className="text-start">{t(row.original.payment_method)}</div>
        ),
      },
      {
        Header: (
          <div className="text-start" title={t("Amount")}>
            {t("Amount")}
          </div>
        ),
        accessor: "amount",
        Cell: ({ row }) => (
          <div className="text-start">
            {`EGP ${row.original.amount?.toFixed(2)}`}
          </div>
        ),
      },
      {
        Header: (
          <div className="text-start" title={t("Running Balance")}>
            {t("Running Balance")}
          </div>
        ),
        accessor: "balance",
        Cell: ({ row }) => (
          <div className="text-start">
            {`EGP ${row.original.balance?.toFixed(2)}`}
          </div>
        ),
      },
    ],
    ...(allStores
      ? [
        {
          Header: (
            <div className="text-start" title={t("Store Name")}>
              {t("Store Name")}
            </div>
          ),
          accessor: "store_name",
          Cell: ({ row }) => (
            <div className="text-start">
              {`${row.original.store_name}`}
            </div>
          ),
        },
      ]
      : []),
    [t]
  );


  const {
    headerGroups,
    prepareRow,
    page,
    nextPage,
    setPageSize,
    state: { pageSize },
  } = useTable(
    {
      columns,
      data: data,
      initialState: { pageSize: 10 },
    },
    useSortBy,
    usePagination,
    useRowSelect
  );

  const [pageIndex, setpageIndex] = useState(1);

  useEffect(() => {
    const pageDetails = {
      limit: pageSize,
      offset: pageSize * (pageIndex - 1) < 0 ? 0 : pageSize * (pageIndex - 1),
    };

    if (pageSize) pagination(pageDetails);
  }, [pageSize, pageIndex]);

  return (
    <>
      <div
        className="container flex flex-col mx-auto mt-4"
        style={{ maxWidth: "100%" }}
      >
        {additionalData?.length == 0 && flag == false ? (
          <div className="h-screen w-[90%] mt-2 ">
            <ShimmerLoader />
          </div>
        ) : (
          <>
            {/* Header Table (Fixed) */}
            <div>
              <table
                className="font-normal  max-w-[100%] sm:w-[97.6%] md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] overflow-hidden rounded-lg"
                style={{ tableLayout: "fixed" }}
              >
                <thead>
                  {headerGroups.map((headerGroup, headerIndex) => {
                    const { key: headerKey, ...headerGroupProps } =
                      headerGroup.getHeaderGroupProps();
                    return (
                      <tr
                        key={headerKey}
                        {...headerGroupProps}
                        className="bg-[#78CFEC66] text-sm font-semibold overflow-hidden whitespace-nowrap"
                      >
                        {headerGroup.headers.map((column, colIndex) => {
                          const { key: columnKey, ...columnProps } =
                            column.getHeaderProps(
                              column.getSortByToggleProps()
                            );
                          return (
                            <th
                              key={columnKey}
                              {...columnProps}
                              className="py-3 whitespace-nowrap"
                              style={{ width: column.width }} // Set column width
                            >
                              <div className="flex items-start ms-2 text-sm ">
                                {column.render("Header")}
                                <span className="">
                                  {column.isSorted ? (
                                    column.isSortedDesc ? (
                                      <img
                                        src={Vectorsorting}
                                        style={{ minHeight: 10, minWidth: 10 }}
                                        alt="vector"
                                      />
                                    ) : (
                                      <img
                                        className="rotate-180"
                                        src={Vectorsorting}
                                        alt="vector"
                                      />
                                    )
                                  ) : (
                                    ""
                                  )}
                                </span>
                              </div>
                            </th>
                          );
                        })}
                      </tr>
                    );
                  })}
                </thead>
              </table>
            </div>

            {/* Body Table (Scrollable) */}
            <div
              className="scrollbar-none bg-[#F6F7F9]"
              style={{
                overflowY: "auto",
                maxHeight: "450px", // Adjust height as needed
              }}
            >
              <table
                className="font-normal max-w-[100%] sm:w-[97.6%]  md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] overflow-hidden rounded-lg"
                style={{ tableLayout: "fixed" }}
              >
                <tbody className="bg-[#ffffff] text-center overflow-hidden">
                  {page.map((row) => {
                    prepareRow(row);
                    return (
                      <React.Fragment key={row.id}>
                        <tr
                          {...row.getRowProps()}
                          className="relative hover:bg-white cursor-pointer transition duration-300 border-b border-gray-300 fixed-row-height"
                        //   onClick={() => openOrderList(row.original.id)}
                        >
                          {row.cells.map((cell, index) => (
                            <td
                              key={index}
                              {...cell.getCellProps()}
                              className={`p-2 text-[#272728] h-1212 text-sm font-normal ${index < row.cells.length - 1 ? "relative" : ""
                                } ${cell?.column?.Header == "Product"
                                  ? "cursor-pointer"
                                  : ""
                                }`}
                              style={{ width: cell.column.width }} // Match column width
                            >
                              {cell.render("Cell")}
                            </td>
                          ))}
                        </tr>
                      </React.Fragment>
                    );
                  })}
                  {page.length === 0 && (
                    <tr>
                      <td colSpan={"100%"}>
                        <Empty
                          className="mt-10"
                          description={t("No data available")}
                        />
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {/* Pagination */}
            <div className="">
              <CustomPagination
                data={data?.length}
                pageIndex={pageIndex}
                pageCount={page?.length}
                canPreviousPage={pageIndex != 1 ? true : false}
                canNextPage={data?.length == pageSize ? true : false}
                gotoPage={(page) => {
                  nextPage(page);
                }}
                previousPage={() => {
                  setpageIndex(pageIndex - 1);
                }}
                nextPage={() => {
                  setpageIndex(pageIndex + 1);
                }}
                pageSize={pageSize}
                setPageSize={(pageSize) => {
                  setpageIndex(1)
                  setPageSize(pageSize);
                }}
              />
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default ExpenseManagementTable;
